import React from "react";
import { t } from "../../../i18n";

const WalletLayout = ({ children }) => {
  return (
    <div className="wallet-layout">
      <div className="wallet-layout-header">
        <h4 className="wallet-layout-header-title">
          {t("gamification2026.wallet.title")}
        </h4>
      </div>
      <div className="wallet-layout-container">
        {children}
      </div>
    </div>
  );
};

export default WalletLayout;
